import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './LoginPage.css';

const LoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const { login } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        document.body.style.maxWidth = '100%';
        document.body.style.margin = '0';
        return () => {
            document.body.style.maxWidth = '';
            document.body.style.margin = '';
        };
    }, []);

    const handleLogin = async (e) => {
        e.preventDefault();
        const success = await login(username, password);
        if (success) {
            navigate('/');
        } else {
            alert('이름 또는 생년월일이 잘못되었습니다.');
        }
    };

    return (
        <div className="login-container">
            <video autoPlay loop muted className="background-video">
                <source src="/mainVideo.mp4" type="video/mp4" />
            </video>
            <form onSubmit={handleLogin} className="login-form">
                <img src="/LogoAndCompany.png" alt="(주) 전우종합기술 로고" className="login-logo" />
                <div className="input-group">
                    <label htmlFor="username">ID</label>
                    <input
                        type="text"
                        id="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                </div>
                <div className="input-group">
                    <label htmlFor="password">PASSWORD</label>
                    <input
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                <button type="submit" className="login-button">로그인</button>
            </form>
        </div>
    );
};

export default LoginPage;
